import { render, staticRenderFns } from "./input-name.vue?vue&type=template&id=13cd910c&"
import script from "./input-name.vue?vue&type=script&lang=js&"
export * from "./input-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports